
interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
  }

  export const initialColumnProjects = [
    { id: 1, name: 'Project Id', checked: true, key: 'recordNumber' }, 
    // { id: 2, name: 'Name', checked: true, key: 'name' },
    { id: 5, name: 'Team', checked: true, key: 'teamName' },
    { id: 6, name: 'PDM', checked: true, key: 'pdm' },
    { id: 8, name: 'Contact', checked: true, key: 'contactName' },
    { id: 10, name: 'ZipCode', checked: true, key: 'zipCode' },
    { id: 11, name: 'Project Status', checked: true, key: 'projectStatus' },
  ];
  export const initialColumnMBUReport = [
    { id: 1, name: 'Section Heading', checked: true, key: 'ProjectDevelopement' }, 
    // { id: 2, name: 'NAME', checked: true, key: 'name' },
    { id: 2, name: 'Action Name', checked: true, key: 'statusName' },
    { id: 3, name: 'Team Name', checked: true, key: 'teamName' },
    { id: 4, name: 'Period Count', checked: true, key: 'statusCount' },
    { id: 5, name: 'YTD Count', checked: true, key: 'statusCount' },
    { id: 6, name: 'Period Volume', checked: true, key: 'salePrice' },
    { id: 7, name: 'YTD Volume', checked: true, key: 'salePrice' },
  ];
  
